import { render, staticRenderFns } from "./NavBarClinicas.vue?vue&type=template&id=5094d62c&scoped=true"
import script from "./NavBarClinicas.vue?vue&type=script&lang=js"
export * from "./NavBarClinicas.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=5094d62c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094d62c",
  null
  
)

export default component.exports